import { render, staticRenderFns } from "./WPanel.vue?vue&type=template&id=62bea308&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports